import { FC } from 'react'
import { Logo } from '../../common/components/Logo'
import { SearchInput } from './SearchInput'
import { Actions } from './Actions'
import HeaderWrapper from './HeaderWrapper'
import HeaderBurger, { HeaderBurgerProps } from './HeaderBurger'

type HeaderProps = HeaderBurgerProps

export const Header: FC<HeaderProps> = ({ onToggleSidebar }) => {
  return (
    <HeaderWrapper>
      <div className="flex items-center gap-2">
        <HeaderBurger onToggleSidebar={onToggleSidebar} className="mr-xxs" />
        <Logo />
        <div className="text-lg font-semibold capitalize">Wellesley</div>
      </div>
      <SearchInput />
      <Actions />
    </HeaderWrapper>
  )
}
